import Vue from 'vue';
import Router from 'vue-router';
import { Dialog, Toast } from 'vant';
import api from '@/api/api';
import storage from 'good-storage';
import checkService from '@/shared/services/check';

Vue.use(Router);
const router = new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'login',
    //   component: () => import('../views/login/login.vue'),
    //   meta: {
    //     title: '登录',
    //   },
    // },
    {
      path: '/',
      redirect: '/initial-page'
    },
    {
      path: '/redirect',
      name: 'redirect',
      component: () => import('../views/redirect/redirect.vue'),
      meta: {
        title: '青岛中瑞',
      },
    },
    {
      path: '/confirm-mobile',
      name: 'confirm-mobile',
      component: () => import('../views/induction/confirm-mobile/confirm-mobile.vue'),
      meta: {
        title: '入职确认',
        requireAuth: false,
      },
    },
    {
      path: '/confirm-mobile-accept',
      name: 'confirm-mobile-accept',
      component: () => import('../views/induction/confirm-mobile-accept/confirm-mobile-accept.vue'),
      meta: {
        title: '入职确认',
        requireAuth: false,
      },
    },
    {
      path: '/confirm-mobile-refuse',
      name: 'confirm-mobile-refuse',
      component: () => import('../views/induction/confirm-mobile-refuse/confirm-mobile-refuse.vue'),
      meta: {
        title: '入职确认',
        requireAuth: false,
      },
    },
    {
      path: '/submit-success',
      name: 'submit-success',
      component: () => import('../views/induction/submit-success/submit-success.vue'),
      meta: {
        title: '入职确认',
        requireAuth: false,
      },
    },
    {
      path: '/confirm-pc',
      name: 'confirm-pc',
      component: () => import('../views/induction/confirm-pc/confirm-pc.vue'),
      meta: {
        title: '入职确认',
        requireAuth: false,
      },
    },
    {
      path: '/confirm-pc-accept',
      name: 'confirm-pc-accept',
      component: () => import('../views/induction/confirm-pc-accept/confirm-pc-accept.vue'),
      meta: {
        title: '入职确认',
        requireAuth: false,
      },
    },
    {
      path: '/confirm-pc-refuse',
      name: 'confirm-pc-refuse',
      component: () => import('../views/induction/confirm-pc-refuse/confirm-pc-refuse.vue'),
      meta: {
        title: '入职确认',
        requireAuth: false,
      },
    },
    {
      path: '/exam-evaluation',
      name: 'exam-evaluation',
      component: () => import('../views/candidate/exam-evaluation/exam-evaluation.vue'),
      meta: {
        title: '考试测评',
        requireAuth: false,
      },
    },
    {
      path: '/interview-notice',
      name: 'interview-notice',
      component: () => import('../views/candidate/interview-notice/interview-notice.vue'),
      meta: {
        title: '面试通知',
        requireAuth: false,
      },
    },
    {
      path: '/interview-evaluation',
      name: 'interview-evaluation',
      component: () => import('../views/candidate/interview-evaluation/interview-evaluation.vue'),
      meta: {
        title: '面试评价',
        requireAuth: false,
      },
    },
    {
      path: '/fill-resume',
      name: 'fill-resume',
      component: () => import('../views/candidate/fill-resume/fill-resume.vue'),
      meta: {
        title: '完善简历',
        requireAuth: false,
      },
    },
    {
      path: '/my-info',
      name: 'my-info',
      component: () => import('../views/candidate/my-info/my-info.vue'),
      meta: {
        title: '我的',
        requireAuth: false,
      },
    },
    {
      path: '/confirm-homepage',
      name: 'confirm-homepage',
      component: () => import('../views/candidate/confirm-homepage/confirm-homepage.vue'),
      meta: {
        title: '登录',
        requireAuth: false,
      },
    },
    {
      path: '/initial-page',
      name: 'initial-page',
      component: () => import('../views/candidate/initial-page/initial-page.vue'),
      meta: {
        title: '青岛中瑞',
        requireAuth: false,
      },
    },
    // {
    //   path: '/resume-detail-pc',
    //   name: 'confirm-homepage',
    //   component: () => import('../views/candidate/resume-manage-pc/resume-detail/resume-detail.vue'),
    //   meta: {
    //     title: '简历详情',
    //     requireAuth: false,
    //   },
    // },
    {
      path: '/resume-detail',
      name: 'confirm-homepage',
      component: () => import('../views/candidate/resume-manage/resume-detail/resume-detail.vue'),
      meta: {
        title: '简历详情',
        requireAuth: false,
      },
    },
    {
      path: '/resume-base-add',
      name: 'confirm-homepage',
      component: () => import('../views/candidate/resume-manage/basic-resume-edit/basic-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/educate-resume-edit',
      name: 'educate-resume-edit',
      component: () => import('../views/candidate/resume-manage/educate-resume-edit/educate-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/workExperiences-resume-edit',
      name: 'workExperiences-resume-edit',
      component: () => import('../views/candidate/resume-manage/workExperiences-resume-edit/workExperiences-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/projects-resume-edit',
      name: 'projects-resume-edit',
      component: () => import('../views/candidate/resume-manage/projects-resume-edit/projects-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/skills-resume-edit',
      name: 'skills-resume-edit',
      component: () => import('../views/candidate/resume-manage/skills-resume-edit/skills-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/rewards-resume-edit',
      name: 'rewards-resume-edit',
      component: () => import('../views/candidate/resume-manage/rewards-resume-edit/rewards-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/trains-resume-edit',
      name: 'trains-resume-edit',
      component: () => import('../views/candidate/resume-manage/trains-resume-edit/trains-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/members-resume-edit',
      name: 'members-resume-edit',
      component: () => import('../views/candidate/resume-manage/members-resume-edit/members-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/positions-resume-edit',
      name: 'positions-resume-edit',
      component: () => import('../views/candidate/resume-manage/positions-resume-edit/positions-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/trades-resume-edit',
      name: 'trades-resume-edit',
      component: () => import('../views/candidate/resume-manage/trades-resume-edit/trades-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/workPlaces-resume-edit',
      name: 'workPlaces-resume-edit',
      component: () => import('../views/candidate/resume-manage/workPlaces-resume-edit/workPlaces-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/resume-list',
      name: 'resume-list',
      component: () => import('../views/candidate/resume-manage/resume-list/resume-list.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/language-resume-edit',
      name: 'language-resume-edit',
      component: () => import('../views/candidate/resume-manage/language-resume-edit/language-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/relationship-resume-edit',
      name: 'relationship-resume-edit',
      component: () => import('../views/candidate/resume-manage/relationship-resume-edit/relationship-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/self-resume-edit',
      name: 'self-resume-edit',
      component: () => import('../views/candidate/resume-manage/self-resume-edit/self-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/enclosure-resume-edit',
      name: 'enclosure-resume-edit',
      component: () => import('../views/candidate/resume-manage/enclosure-resume-edit/enclosure-resume-edit.vue'),
      meta: {
        title: '我的简历',
        requireAuth: false,
      },
    },
    {
      path: '/add-resume',
      name: 'add-resume',
      component: () => import('../views/resume/add/add.vue'),
      meta: {
        title: '简历投递',
        requireAuth: false,
      },
    },
    // {
    //   path: '*',
    //   redirect: '/', // URL匹配不到静态资源时跳转登录页
    // },

  ]
});

// 判定使用的变量
declare const WeixinJSBridge: any;
const WECHAT_CORPID = process.env.VUE_APP_WECHAT_CORPID;
const WECHAT_APPID = process.env.VUE_APP_APPROVAL_APPID;
const WECHAT_BINDURL = process.env.VUE_APP_WECHAT_BINDURL;
const APPROVAL_SECRET = process.env.VUE_APP_APPROVAL_SECRET;

function closePage() {
  const userAgent = navigator.userAgent;
  // Firefox或Chrome中关闭
  if (userAgent.indexOf('Firefox') !== -1 || userAgent.indexOf('Chrome') !== -1) {
    window.location.href = 'about:blank';
  } else {
    window.opener = null;
    window.open('', '_self');
    window.close();
  }
  // 微信中关闭
  if (WeixinJSBridge) {
    WeixinJSBridge.call('closeWindow');
  }
}

function errorClose(errorMsg: any) {
  Toast.clear();
  Dialog.alert({
    title: '错误',
    message: errorMsg,
  }).then(() => {
    closePage();
  });
}

function wxRedireURL() {
  const encodeURL = encodeURI(window.location.href);
  // window.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + WECHAT_CORPID + '&redirect_uri=' + encodeURL + '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect');
}

// 验证绑定、登录
const authLogin = (to: any, next: any) => {
  Toast.loading({
    message: '正在初始化...',
    forbidClick: true,
    loadingType: 'spinner',
    duration: 0,
  });
  if (window.location.href.indexOf('code') === -1) {
    // 路由参数存至缓存
    if (checkService.isNotNull(to.query)) {
      storage.set('THIS_LOCATION_HREF_QUERY', JSON.stringify(to.query));
    }
    storage.set('PATH_ROUTE', to.path);
    wxRedireURL();
  } else {
    // 截取code
    const codeStr = window.location.href.split('&')[0].split('code=')[1];

    // 4、认证中心登录
    const login = (bindCode: any) => {
      const entity = {
        username: bindCode.code,
        accountId: bindCode.code,
        grantType: 'wechat_social_credentials'
      }
      api.login(entity).then((res: any) => {
        const loginData = res.data;
        // 将TOKEN存到localStorage中
        const expDate = new Date();
        expDate.setTime(expDate.getTime() + loginData.expires_in * 1000);
        storage.set('EXPDATE', expDate.getTime());
        storage.set('AUTHTOKEN', loginData.token_type + ' ' + loginData.access_token);
        storage.set('CURLOGINNAME', bindCode.code);
        Toast.clear();
        window.location.replace(window.location.origin + '/#' + storage.get('PATH_ROUTE'));
      }).catch(() => {
        Toast.clear();
        // 登录绑定
        next({
          path: '/',
          query: { redirect: to.fullPath },
        });
      });
    };

    // 3、验证是否已经绑定
    const getIsbind = (bindCode: any) => {
      api.getIsbind(bindCode, (bind: any) => {
        // 如果已绑定则模拟登录获取TOKEN，否则绑定
        if (bind.data === true) {
          // 4、认证中心登录
          login(bindCode);
        } else {
          storage.remove('EXPDATE');
          storage.remove('AUTHTOKEN');
          storage.remove('CURLOGINNAME');
          Toast.clear();
          window.location.replace(WECHAT_BINDURL + encodeURIComponent(window.location.origin + '/#' + storage.get('PATH_ROUTE')));
        }
      }, (error: any) => {
        errorClose(error);
      });
    };

    // 2、获取userCode
    const getUserCode = (params: any) => {
      api.getUserInfo(params, (userinfo: any) => {
        if (userinfo.data && userinfo.data.errcode === '0' && userinfo.data.userId) {
          const bindCode = {
            code: userinfo.data.userId,
          };
          // 3、验证是否已经绑定
          getIsbind(bindCode);
        } else {
          wxRedireURL();
        }
      }, (error: any) => {
        errorClose(error);
      });
    };

    // 1、获取accessToken
    const param = {
      sCorpID: WECHAT_CORPID,
      appId: WECHAT_APPID,
      secret: APPROVAL_SECRET
    };
    api.getAccesstoken(param, (accessToken: any) => {
      if (accessToken.data) {
        const params = {
          accessToken: accessToken.data,
          code: codeStr,
        };
        // 2、获取code
        getUserCode(params);
      } else {
        wxRedireURL();
      }
    }, (error: any) => {
      errorClose(error);
    });
  }
}

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 如果未匹配到路由
  if (to.matched.length === 0) {
    // 如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
    from.name ? next({ name: from.name }) : next('/');
  } else {
    if (to.meta.title) {
      document.title = to.meta.title;
    }

    // 如果不需要身份验证
    if (!to.meta.requireAuth) {
      document.title = to.meta.title;
      //  如果参数中存在wechatlogin，认为是微信的回调
      const query = new URLSearchParams(location.search);
      if (query.get('wechatlogin')) {
        // 跳转到参数中指定的路由
        const targetPage = query.get('wechatlogin');
        query.delete('wechatlogin');
        window.location.replace(window.location.origin + '/#/' + targetPage + '?' + query.toString());
      } else {
        next();
      }
      return;
    }

    // // 本地调试
    next();
    return;

    /**
     * 检查是否已有身份信息
     * 检查是否超出过期时间
     */
    const expDate = storage.get('EXPDATE');
    const dateNow = new Date();
    if (expDate && (dateNow.getTime().toString() < expDate.toString())) {
      if (to.meta.title) {
        document.title = to.meta.title;
        storage.set('PATH_ROUTE', to.path);
      }
      // 刷新缓存
      if (checkService.isNotNull(to.query)) {
        storage.set('THIS_LOCATION_HREF_QUERY', JSON.stringify(to.query));
      }
      next();
      return;
    } else {
      authLogin(to, next);
    }
  }
});

export default router;

